import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";

// Register service worker for PWA
if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then((registration) => {
				console.log('SW registered: ', registration);
				
				// Listen for messages from service worker (for notification clicks)
				navigator.serviceWorker.addEventListener('message', (event) => {
					if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
						const url = event.data.url;
						if (url) {
							window.location.href = url;
						}
					}
				});
			})
			.catch((registrationError) => {
				console.log('SW registration failed: ', registrationError);
			});
	});

	// Also listen for messages if service worker is already active
	if (navigator.serviceWorker.controller) {
		navigator.serviceWorker.addEventListener('message', (event) => {
			if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
				const url = event.data.url;
				if (url) {
					window.location.href = url;
				}
			}
		});
	}
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
